/* CUSTOM_HOUSEDOCS_BY_CLAUDE (AIOPS ab5481f30c85, Ryan 2026-09-11)
   ─────────────────────────────────────────────────────────────────────────────
   Settings → Admin: House Documents — the JS half. Markup in
   snippets/rep-settings-house-docs.liquid.

   ⛔ ITS OWN ASSET BECAUSE THE SECTION IS FULL (rep-quote-settings.liquid is at Shopify's 256 KB
   template cap). Same precedent as rep-settings-agent-panels.js.

   ⚠️ THE FILE IS READ IN THE BROWSER AND POSTED AS BASE64. The worker has no multipart parser and
   every other upload in this portal goes the same way; a 3 MB cap keeps the JSON body sane and
   matches what a reply can actually carry. FileReader gives a data: URL, so the prefix up to the
   first comma is dropped — sending it would make the bytes unparseable base64 and the refusal
   would read as "your PDF is corrupt".

   Loaded deferred after custom-rep-portal.js (which defines window.RepPortal.API); runs on
   DOMContentLoaded. showMsg / hideMsg are the section's two helpers, copied because they are
   IIFE-local there. */
(function () {
  'use strict';

  var MAX_B64 = 3 * 1024 * 1024;

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) {
    if (!el) return;
    el.className = 'rep-settings__message';
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function kb(n) {
    var v = Number(n) || 0;
    return v >= 1048576 ? (v / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(v / 1024)) + ' KB';
  }

  function initHouseDocs() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var list = document.getElementById('settings-housedocs-list');
    var slug = document.getElementById('settings-housedocs-slug');
    var note = document.getElementById('settings-housedocs-note');
    var file = document.getElementById('settings-housedocs-file');
    var btn = document.getElementById('settings-housedocs-btn');
    var msg = document.getElementById('settings-housedocs-msg');
    if (!list || !btn || !file || !slug) return;

    function load() {
      list.innerHTML = '<p style="font-size:13px;color:var(--rq-text-secondary);margin:0;">Loading&hellip;</p>';
      window.RepPortal.API.get('/house-docs').then(function (d) {
        var items = (d && d.items) || [];
        if (!items.length) {
          /* ⚠️ "Nothing here yet" is a real state, not a failed load — the catch below is what
             reports a failure, and the two must not look alike. */
          list.innerHTML = '<p style="font-size:13px;color:var(--rq-text-secondary);margin:0;">Nothing on the shelf yet. Add the first document below.</p>';
          return;
        }
        list.innerHTML = items.map(function (it) {
          /* CUSTOM_HOUSEDOCFILL_BY_CLAUDE (AIOPS f0809ba0480e, Ryan 2026-09-18) - a document we
             know how to type a PO number and a date onto says so, and offers to show you one.
             Absent on every other document rather than "not fillable" on all of them. */
          var fillable = it.fill && it.fill.fillable;
          var fields = fillable && it.fill.fields
            ? it.fill.fields.map(function (f) { return f.label; }).join(' and ')
            : '';
          return '<div style="border:1px solid var(--rq-border,#1e2a42);border-radius:8px;padding:10px 12px;margin:0 0 8px;">'
            + '<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">'
            + '<strong style="font-size:14px;">' + esc(it.slug) + '</strong>'
            + '<span style="font-size:12px;color:var(--rq-text-secondary);">' + esc(it.name) + ' &middot; ' + kb(it.bytes) + '</span>'
            + '<button type="button" class="rep-settings__submit rep-settings__housedoc-del"'
            + ' data-slug="' + esc(it.slug) + '" style="margin-left:auto;padding:4px 12px;font-size:12px;">Remove</button>'
            + '</div>'
            + (it.note ? '<p style="margin:6px 0 0;font-size:12px;color:var(--rq-text-secondary);">' + esc(it.note) + '</p>' : '')
            + (fillable
              ? '<p style="margin:6px 0 0;font-size:12px;color:var(--rq-text-secondary);">'
                + 'An agent can type the ' + esc(fields) + ' onto this one before attaching it. '
                + '<button type="button" class="rep-settings__housedoc-fill" data-slug="' + esc(it.slug) + '"'
                + ' style="background:none;border:none;padding:0;color:var(--rq-accent,#006BCC);cursor:pointer;font-size:12px;text-decoration:underline;">'
                + 'Show me a filled copy</button></p>'
              : '')
            + '</div>';
        }).join('');
      }).catch(function (e) {
        list.innerHTML = '<p style="font-size:13px;color:var(--rq-error,#e08a80);margin:0;">Could not read the shelf: '
          + esc(e && e.message ? e.message : 'unknown error') + '</p>';
      });
    }

    /* ⛔ ONE DELEGATED LISTENER — load() replaces every row, so per-button listeners would die on
       the first refresh and Remove would silently stop working. */
    list.addEventListener('click', function (e) {
      /* CUSTOM_HOUSEDOCFILL_BY_CLAUDE (AIOPS f0809ba0480e, Ryan 2026-09-18) — the eyeball check.
         ⚠️ IT RENDERS A REAL FILLED COPY rather than saying "fillable", because the only thing
         that can go wrong here is the text landing off the printed line, and no status word can
         show you that. It uses a made-up PO number and today's date, sends nothing, and nothing
         is stored: the file opens in a new tab and is gone when you close it. */
      var fb = e.target && e.target.closest && e.target.closest('.rep-settings__housedoc-fill');
      if (fb) {
        var fslug = fb.getAttribute('data-slug');
        if (!fslug) return;
        fb.disabled = true;
        var was = fb.textContent;
        fb.textContent = 'Filling...';
        window.RepPortal.API.post('/house-doc-fill', { slug: fslug, poNumber: 'SAMPLE-1234' }).then(function (res) {
          if (!res || !res.base64) throw new Error('nothing came back');
          var bin = atob(res.base64);
          var bytes = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
          var url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
          window.open(url, '_blank');
          /* The tab has to read it first; revoking immediately gives a blank viewer. */
          setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
          showMsg(msg, 'Opened a filled copy of "' + fslug + '" with a made-up PO number. Nothing was sent or saved.', 'success');
        }).catch(function (err) {
          showMsg(msg, 'Could not fill ' + fslug + ': ' + (err && err.message ? err.message : 'unknown error'), 'error');
        }).then(function () {
          fb.disabled = false;
          fb.textContent = was;
        });
        return;
      }
      var b = e.target && e.target.closest && e.target.closest('.rep-settings__housedoc-del');
      if (!b) return;
      var s = b.getAttribute('data-slug');
      if (!s) return;
      /* Two clicks: the button says Remove, then Sure? — a document nobody notices has gone is
         one Abby stops being able to attach, with no error to read. */
      if (b.getAttribute('data-armed') !== '1') {
        b.setAttribute('data-armed', '1');
        b.textContent = 'Sure?';
        setTimeout(function () { b.setAttribute('data-armed', '0'); b.textContent = 'Remove'; }, 4000);
        return;
      }
      b.disabled = true;
      b.textContent = 'Removing...';
      window.RepPortal.API.post('/admin/house-doc-delete', { slug: s }).then(function () {
        showMsg(msg, 'Removed "' + s + '". Abby can no longer attach it.', 'success');
        load();
      }).catch(function (err) {
        showMsg(msg, 'Could not remove ' + s + ': ' + (err && err.message ? err.message : 'unknown error'), 'error');
        b.disabled = false;
        b.textContent = 'Remove';
      });
    });

    btn.addEventListener('click', function () {
      hideMsg(msg);
      var f = file.files && file.files[0];
      var s = (slug.value || '').trim();
      if (!s) { showMsg(msg, 'Give it a short name first, e.g. tax-exemption-multistate.', 'error'); return; }
      if (!f) { showMsg(msg, 'Choose a PDF, Word, JPG or PNG file.', 'error'); return; }
      var reader = new FileReader();
      reader.onerror = function () { showMsg(msg, 'Could not read that file off your machine.', 'error'); };
      reader.onload = function () {
        var dataUrl = String(reader.result || '');
        var comma = dataUrl.indexOf(',');
        var b64 = comma === -1 ? '' : dataUrl.slice(comma + 1);
        if (!b64) { showMsg(msg, 'That file came back empty.', 'error'); return; }
        if (b64.length > MAX_B64) {
          showMsg(msg, 'That file is over the 3 MB limit, which is the most an email can carry.', 'error');
          return;
        }
        btn.disabled = true;
        var orig = btn.textContent;
        btn.textContent = 'Uploading...';
        window.RepPortal.API.post('/admin/house-doc', {
          slug: s,
          name: f.name,
          contentType: f.type || undefined,
          base64: b64,
          note: (note && note.value ? note.value.trim() : ''),
        }).then(function (res) {
          showMsg(msg, res && res.replaced
            ? 'Replaced "' + s + '". Every reply from now on attaches the new file.'
            : 'On the shelf as "' + s + '". Abby can attach it by that name.', 'success');
          file.value = '';
          load();
        }).catch(function (e) {
          showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
        }).then(function () {
          btn.disabled = false;
          btn.textContent = orig;
        });
      };
      reader.readAsDataURL(f);
    });

    load();
    initPending(msg, load);
  }

  /* CUSTOM_HOUSEDOCPROPOSE_BY_CLAUDE (KAREN 845cfff6c50e, Ryan 2026-09-29) - the agent-proposed
     documents waiting on Ryan, the count on the section title, and the email switch.
     ⛔ APPROVE SENDS THE `proposedAt` THE PAGE LOADED, so the worker refuses if the proposal was
     rejected and re-filed under the same name in between: the file approved is the file viewed.
     ⚠️ The switch is saved on its own click and re-read after, never assumed. */
  function initPending(msg, reloadShelf) {
    var wrap = document.getElementById('settings-housedocs-pending-wrap');
    var box = document.getElementById('settings-housedocs-pending');
    var badge = document.getElementById('settings-housedocs-pending-badge');
    var email = document.getElementById('settings-housedocs-email');
    if (!wrap || !box) return;

    function loadPending() {
      window.RepPortal.API.get('/house-doc-proposals').then(function (d) {
        var items = (d && d.items) || [];
        if (email && d && d.config) email.checked = !!d.config.emailRyan;
        if (badge) {
          badge.hidden = !items.length;
          badge.textContent = items.length ? items.length + ' pending' : '';
        }
        wrap.hidden = !items.length;
        box.innerHTML = items.map(function (p) {
          return '<div style="border:1px solid #d97706;border-radius:8px;padding:10px 12px;margin:0 0 8px;">'
            + '<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">'
            + '<strong style="font-size:14px;">' + esc(p.slug) + '</strong>'
            + '<span style="font-size:12px;color:var(--rq-text-secondary);">' + esc(p.name) + ' &middot; ' + kb(p.bytes)
            + ' &middot; from ' + esc(p.proposedBy || 'an agent') + '</span>'
            + (p.replaces ? '<span style="font-size:12px;font-weight:700;color:#d97706;">Replaces: ' + esc(p.replaces.name || p.replaces.slug) + '</span>' : '')
            + '</div>'
            + '<p style="margin:6px 0 8px;font-size:12px;color:var(--rq-text-secondary);">' + esc(p.note) + '</p>'
            + '<div style="display:flex;gap:8px;">'
            + '<button type="button" class="rep-settings__submit rep-settings__hdp" data-act="view" data-slug="' + esc(p.slug) + '" style="padding:4px 12px;font-size:12px;">View</button>'
            + '<button type="button" class="rep-settings__submit rep-settings__hdp" data-act="approve" data-slug="' + esc(p.slug) + '" data-at="' + esc(p.proposedAt) + '" style="padding:4px 12px;font-size:12px;">' + (p.replaces ? 'Approve and replace' : 'Approve') + '</button>'
            + '<button type="button" class="rep-settings__submit rep-settings__hdp" data-act="reject" data-slug="' + esc(p.slug) + '" style="padding:4px 12px;font-size:12px;">Reject</button>'
            + '</div></div>';
        }).join('');
      }).catch(function (e) {
        /* ⚠️ A failed load is said out loud; an empty list and a broken one must not look alike. */
        wrap.hidden = false;
        box.innerHTML = '<p style="font-size:13px;color:var(--rq-error,#e08a80);margin:0;">Could not read the pending documents: '
          + esc(e && e.message ? e.message : 'unknown error') + '</p>';
      });
    }

    /* ⛔ ONE DELEGATED LISTENER - loadPending() replaces every row. */
    box.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.rep-settings__hdp');
      if (!b) return;
      var slug = b.getAttribute('data-slug');
      var act = b.getAttribute('data-act');
      if (!slug) return;
      if (act === 'view') {
        b.disabled = true;
        window.RepPortal.API.get('/admin/house-doc-proposal-file?slug=' + encodeURIComponent(slug)).then(function (res) {
          if (!res || !res.base64) throw new Error('nothing came back');
          var bin = atob(res.base64);
          var bytes = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
          var url = URL.createObjectURL(new Blob([bytes], { type: res.contentType || 'application/pdf' }));
          window.open(url, '_blank');
          setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
        }).catch(function (err) {
          showMsg(msg, 'Could not open ' + slug + ': ' + (err && err.message ? err.message : 'unknown error'), 'error');
        }).then(function () { b.disabled = false; });
        return;
      }
      if (act === 'approve') {
        b.disabled = true;
        window.RepPortal.API.post('/admin/house-doc-proposal-approve', { slug: slug, proposedAt: b.getAttribute('data-at') }).then(function (res) {
          showMsg(msg, res && res.replaced
            ? 'Approved. "' + slug + '" on the shelf now has the new file, and Abby attaches it from now on.'
            : 'Approved. "' + slug + '" is on the shelf and Abby can attach it by that name.', 'success');
          loadPending();
          reloadShelf();
        }).catch(function (err) {
          showMsg(msg, 'Could not approve ' + slug + ': ' + (err && err.message ? err.message : 'unknown error'), 'error');
          b.disabled = false;
        });
        return;
      }
      if (act === 'reject') {
        var reason = window.prompt('Reject "' + slug + '"? The file is deleted. Say why, so the agent does not send it again:', '');
        if (reason === null) return;
        b.disabled = true;
        window.RepPortal.API.post('/admin/house-doc-proposal-reject', { slug: slug, reason: reason }).then(function () {
          showMsg(msg, 'Rejected "' + slug + '". The file was deleted and the agent was told why.', 'success');
          loadPending();
        }).catch(function (err) {
          showMsg(msg, 'Could not reject ' + slug + ': ' + (err && err.message ? err.message : 'unknown error'), 'error');
          b.disabled = false;
        });
      }
    });

    if (email) {
      email.addEventListener('change', function () {
        var want = !!email.checked;
        email.disabled = true;
        window.RepPortal.API.post('/admin/house-doc-proposal-config', { emailRyan: want }).then(function (res) {
          email.checked = !!(res && res.config && res.config.emailRyan);
          showMsg(msg, email.checked ? 'You will get an email when an agent proposes a document.' : 'No email. Proposals show here as a pending count.', 'success');
        }).catch(function (err) {
          email.checked = !want;
          showMsg(msg, 'Could not save the email setting: ' + (err && err.message ? err.message : 'unknown error'), 'error');
        }).then(function () { email.disabled = false; });
      });
    }

    loadPending();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHouseDocs);
  } else {
    initHouseDocs();
  }
})();
